export default __webpack_public_path__ + "static/Case-Study-Global-clothing-retailer-6581bdc9160977a2fa0d1224bf8875c7.pdf";